/**
 * Notification category definitions
 * Maps API enum values to user-friendly display information
 * These categories match the backend NotificationCategory enum
 */

import {
  NotificationCategory,
  NotificationChannelPreference,
} from '../types/Notifications'

/**
 * List of all notification categories
 * Order determines display order in UI
 */
export const NOTIFICATION_CATEGORIES: NotificationCategory[] = [
  {
    value: 'game_updates',
    title: 'Game Updates',
    description:
      'Updates on upcoming games, rescheduled games, live streams and game status changes',
    icon: '🏀',
  },
  {
    value: 'player_status',
    title: 'Player Status',
    description: 'Game Attendance, Suspensions and Injuries',
    icon: '👤',
  },
  {
    value: 'in_game_events',
    title: 'In-Game Events',
    description: 'Updates on goals, penalties, and period endings',
    icon: '🏀',
  },
  {
    value: 'registration_payments',
    title: 'Registrations & Payments',
    description:
      'Confirmations for registrations, payments and other registration updates',
    icon: '💳',
  },
  {
    value: 'social_communication',
    title: 'Social & Communication',
    description: 'League Communications',
    icon: '📧',
  },
  {
    value: 'chat',
    title: 'Team Chat',
    description: 'Team Chat Notifications',
    icon: '💬',
  },
]

/**
 * Default preference values for new categories
 * Matches backend defaults from migration
 */
export const DEFAULT_PREFERENCES: NotificationChannelPreference = {
  push_enabled: true,
  email_enabled: true,
  sms_enabled: false,
}
